(function () {
  'use strict';

  if (window.LuxeScroll) return;

  var consumers = [];

  var state = { y: 0, dy: 0, speed: 0, vh: 0, docH: 0, progress: 0 };

  var metricsDirty = true;
  var forced = true;
  var busy = false;
  var lastY = -1;

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  function scrollY() {
    return window.pageYOffset || window.scrollY || document.documentElement.scrollTop || 0;
  }

  function readMetrics() {
    state.vh = window.innerHeight || document.documentElement.clientHeight || 0;
    state.docH = Math.max(0, (document.documentElement.scrollHeight || 0) - state.vh);
    metricsDirty = false;
  }

  function frame() {
    var y = scrollY();

    state.dy = lastY < 0 ? 0 : y - lastY;
    state.speed = state.dy < 0 ? -state.dy : state.dy;
    state.y = y;
    lastY = y;

    if (!forced && !busy && state.dy === 0) return;
    forced = false;

    if (metricsDirty) readMetrics();
    state.progress = state.docH > 0 ? clamp(y / state.docH, 0, 1) : 0;

    for (var i = 0; i < consumers.length; i++) {
      var m = consumers[i].measure;
      if (m) m(state);
    }

    var stillBusy = false;
    for (var j = 0; j < consumers.length; j++) {
      var p = consumers[j].paint;
      if (p && p(state)) stillBusy = true;
    }
    busy = stillBusy;
  }

  var onTicker = false;
  var ownRaf = 0;

  function ownLoop() {
    frame();
    if (!onTicker && (busy || forced || state.dy !== 0)) {
      ownRaf = requestAnimationFrame(ownLoop);
    } else {
      ownRaf = 0;
    }
  }

  function wake() {
    if (onTicker) return;
    if (!ownRaf) ownRaf = requestAnimationFrame(ownLoop);
  }

  function useTicker() {
    var g = window.gsap;
    if (onTicker || !g || !g.ticker || !g.ticker.add) return false;
    g.ticker.add(frame);
    onTicker = true;
    if (ownRaf) {
      cancelAnimationFrame(ownRaf);
      ownRaf = 0;
    }
    return true;
  }

  if (!useTicker()) {
    wake();
    var waits = 0;
    (function waitForGsap() {
      if (useTicker() || waits++ > 300) return;
      requestAnimationFrame(waitForGsap);
    })();
  }

  function invalidate() {
    metricsDirty = true;
    forced = true;
    wake();
  }

  window.addEventListener('resize', invalidate, { passive: true });
  window.addEventListener('orientationchange', invalidate, { passive: true });
  window.addEventListener('load', invalidate);

  window.addEventListener('scroll', wake, { passive: true });

  if ('ResizeObserver' in window) {
    var roPending = 0;
    var ro = new ResizeObserver(function () {
      if (roPending) return;
      roPending = requestAnimationFrame(function () {
        roPending = 0;
        invalidate();
      });
    });
    ro.observe(document.documentElement);
  }

  window.LuxeScroll = {
    state: state,
    invalidate: invalidate,
    register: function (consumer) {
      if (!consumer) return function () {};
      consumers.push(consumer);
      forced = true;
      wake();
      return function () {
        var i = consumers.indexOf(consumer);
        if (i !== -1) consumers.splice(i, 1);
      };
    }
  };
})();
